import { useQuery } from '@tanstack/react-query'
import { fileUrl } from '@tnn/core'
import { InitialsAvatar, type InitialsAvatarProps } from '@tnn/ui'
import { api } from '../api/client'

/** Everyone's photo by staff record and by account (`GET /api/photos`), kept a few minutes */
export interface PhotoDirectory {
  employees: Record<string, string>
  users: Record<string, string>
}

export const photosQueryKey = ['photos'] as const

export function usePhotos() {
  return useQuery({ queryKey: photosQueryKey, queryFn: () => api.get<PhotoDirectory>('/photos'), staleTime: 5 * 60_000 }).data
}

/**
 * A person's avatar: their photo when they have one — given (`fileId`), or found by their account (`userId`) or staff
 * record (`employeeId`) — else the first letter of their name
 */
export function PersonAvatar({
  fileId,
  userId,
  employeeId,
  ...rest
}: InitialsAvatarProps & { fileId?: string | null; userId?: string | null; employeeId?: string | null }) {
  const photos = usePhotos()
  const photo = fileId ?? (userId && photos?.users[userId]) ?? (employeeId && photos?.employees[employeeId]) ?? null
  return <InitialsAvatar {...rest} src={photo ? fileUrl(photo) : undefined} alt="" />
}
